import { createSlice } from "@reduxjs/toolkit";
import {
  getPurchasingReportList,
  getPurchasingFilteredData,
  resetPurchasingFilteredData,
} from "../services/purchasingServices";

let initialState = {
  isLoading: false,
  pages: 0,
  errors: null,
  data: [],
  // Filter data
  filteredData: [],
};

const reportsPurchaseOrderSLice = createSlice({
  name: "reportsPurchasing",
  initialState,
  extraReducers: (builder) => {
    /* -------------------------------------------- Get purchaseOrder Reports List ------------------------------------ */
    builder.addCase(getPurchasingReportList.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(getPurchasingReportList.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || null;
      state.errors = null;
    });
    builder.addCase(getPurchasingReportList.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });

    /* --------------------------------------------------- get Purchase Order Filtered Data------------------------------------------------ */
    builder.addCase(getPurchasingFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(
      getPurchasingFilteredData.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        state.filteredData = payload;
        state.errors = null;
      }
    );
    builder.addCase(getPurchasingFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });

    /* --------------------------------------------------- reset Purchase Order Filtered Data------------------------------------------------ */
    builder.addCase(resetPurchasingFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(
      resetPurchasingFilteredData.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        // state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || [];
        state.filteredData = [];
        state.errors = null;
      }
    );
    builder.addCase(resetPurchasingFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
  },
});

export default reportsPurchaseOrderSLice.reducer;
